import { FC } from "react";

import {
  FontIcon,
  FontSizes,
  FontWeights,
  mergeStyles,
  Stack,
  useTheme
} from "@bps/fluent-ui";

import { ClaimStatusBadgeProps } from "./ClaimStatusBadge.types.ts";
import { wrapBadge } from "./utils.tsx";

export const ClaimStatusIconBadge: FC<ClaimStatusBadgeProps> = props => {
  const theme = useTheme();

  const badgeStyles = mergeStyles(
    {
      width: 105,
      justifyContent: "center",
      alignItems: "center",
      color: theme.palette.neutralSecondary,
      fontSize: FontSizes.size14,
      fontWeight: FontWeights.regular
    },
    props.styles?.badge
  );

  return wrapBadge(
    <Stack horizontal styles={{ root: badgeStyles }}>
      <FontIcon
        iconName={props.icon}
        styles={{
          root: {
            color: props.textColor,
            marginRight: 4,
            fontSize: FontSizes.size16,
            ...props.styles?.icon
          }
        }}
      />
      {props.text}
    </Stack>,
    props.styles?.root
  );
};
